<template>
<div>
 
<Subtitle  v-bind:ServiceID="this.AppServiceID">
<template v-slot:header>
<i class="fab fa-product-hunt"></i><b>  Manage Provider:</b>
</template> 
</Subtitle>  
<Card>
  <CardBody>
    <p>Manage Provider is an Administration action. Any change in this section will affect the web application and its access level. All transactions are monitored, logged and reviewed.
    </p> 
</CardBody>
</Card> 
<b-modal id="infoModal" size="lg" v-model="showInfoModal"  no-close-on-esc no-close-on-backdrop hide-header-close
    ok-variant cancel-variant hide-footer
     header-class="PopUpHeader" 
    :body-bg-variant=PopUpVar.bodyBgVariant
    :body-text-variant=PopUpVar.bodyTextVariant
    :footer-bg-variant=PopUpVar.footerBgVariant
    :footer-text-variant=PopUpVar.footerTextVariant> 
    <ProviderDetails v-if="showInfoModal==true" :UserData="UserData"></ProviderDetails>
    <template slot="modal-header"   slot-scope="{ close }"> 
      <div>
      <small class="modal-title w-100 text-left"></small>
    </div> 
    <div><small class="PopUpTitle">Provider Details</small></div>
    <div><small class="modal-title w-100 text-right"></small></div>
  </template> 
    
</b-modal> 
<b-modal id="editModal" v-model="showEditModal"  no-close-on-esc no-close-on-backdrop hide-header-close
    ok-variant cancel-variant hide-footer
     header-class="PopUpHeader" 
    :body-bg-variant=PopUpVar.bodyBgVariant
    :body-text-variant=PopUpVar.bodyTextVariant
    :footer-bg-variant=PopUpVar.footerBgVariant
    :footer-text-variant=PopUpVar.footerTextVariant> 
    <ProviderAddEdit v-if="showEditModal==true" :UserData="UserData" :mode="mode" @providerUpdated="closeModal"  ></ProviderAddEdit>
    <template slot="modal-header"   slot-scope="{ close }"> 
    <div>
        <small class="PopUpTitle w-100 text-left">{{mode}} Provider</small>
    </div> 
    <div v-show="mode=='Edit'"><small class="PopUpTitle w-100 text-right">Provider Number: {{UserData.providernumber}}</small></div>
    </template> 
     
</b-modal> 

<v-client-table :columns="columns" :data="tableData" :options="options" class="mb-2">
  <!-- <span slot-scope="props"  slot="status" v-if="props.row.status.toUpperCase() == 'ACTIVE'" style="color:green"><i class="fas fa-check-circle"  
     v-b-tooltip.hover.right="'Active'"></i></span>
  <span slot-scope="props"  v-else-if="props.row.status.toUpperCase() == 'INACTIVE'" style="color:red"><i class="fas fa-times-circle" 
     v-b-tooltip.hover.right="'Inactive'"></i></span>  -->

<!-- <span class="pointer" v-on:click="EditProviderPopup(props.row)" slot="edit" slot-scope="props" ><i class="far fa-edit"></i></span> -->
<!-- <span class="pointer" v-on:click="ProviderDetailsPopup(props.row)" slot="info" slot-scope="props" ><i class="far fa-question-circle"></i></span> -->
  <span class="pointer" v-on:click="ProviderDetailsPopup(props.row)" slot="info" slot-scope="props" ><i class="far fa-question-circle"></i></span>
     
 <!-- <div   v-if="showEdit" slot="beforeFilter"  class="VueTables_Adduser">
<label for="VueTables_Adduser" class="VueTables_user"> Add New Provider: </label>
  <button type="button" v-on:click="AddProviderPopup" class="btn btn-primary form-control ">ADD Provider</button>
</div> -->
</v-client-table>
<div class="mt-3">

</div>
</div>
</template>

<script>
import {mapGetters} from 'vuex'
import axios from 'axios'
import Vue from 'vue';
import moment from 'moment'
import Card from "@/Common/Card.vue";
import CardBody from "@/Common/CardBody.vue";
import TileNote from "@/Common/TileNote.vue";
import Modal from '../../../Common/ModelPop.vue';
import ProviderAddEdit from '@/components/DPEBB/Administrator/ProviderAddEdit.vue';
import { PopUpVariant } from '@/Common/Default/PopUpVariant';
import ProviderDetails from '@/components/DPEBB/Administrator/ProviderDetails.vue';
import Subtitle from '@/Common/Default/SubTitle.vue';  
import { scrypt } from 'crypto';
export default {
    props:{
        AllowEdit:'',
    },
    data: function(){
        return{
           AppServiceID:6,
             showEdit:true,
             showEditModal:false,
              PopUpVar:PopUpVariant,
               UserData:'',
               orgid:'',
               mode:'',
               showInfoModal:false,
columns: ['status','info','surname', 'givenname','providernumber','servicetype','servicesubtype',
        'effectivedate', 'expirydate','address','businessphonenumber','specialtyallowed'],
        // 'effectivedate', 'expirydate','address','address1','address2','address3','provincecode','postalcode','businessphonenumber','specialtyallowed'],
        tableData: [],
        options: {
        texts:{
              count:"Showing {from} to {to} of {count} records|{count} records|One record",
              first:'First',
              last:'Last',
              filter:"Search Provider Data:",
              filterPlaceholder:"Search in table",
              limit:"Records:",
              page:"Page:",
              noResults:"No matching records",
              filterBy:"Filter by {column}",
              loading:'Loading...',
              defaultOption:'Select {column}',
              columns:'Columns'
          }, 
       
          responseAdapter({data}) {
           
              return {
                data: formatData,
                count: data.length
              };
             
            },
         
          perPage:10,
          perPageValues:[10,15,25],
          dateColumns:['effectivedate','expirydate'],
          toMomentFormat: 'YYYY-MM-DD',
         
          templates: {
            effectivedate(h, row){
              return moment(row.effectivedate, "YYYY-MM-DD").format('YYYY/MM/DD'); 
            },
            expirydate(h, row) {
              return moment(row.expirydate, "YYYY-MM-DD").format('YYYY/MM/DD'); 
            },
             address(h, row) { 
               if(row.address1 =="" && row.address2 == "" && row.address3 == "")
              return <div style="padding-right:0px !important"> <span>{row.address1}  {"  "} {row.address2} </span><span><br/>    {row.address3}  {"  "}{row.provincecode}  {" "} {row.postalcode}</span></div>;
              
              if(row.address1 =="" || row.address1 ==null) 
              return <div style="padding-right:0px !important"> <span>{row.address1}  {"  "} {row.address2} </span><span><br/>    {row.address3}  {" , "}{row.provincecode}  {" "} {row.postalcode}</span></div>;
              else
              return <div style="padding-right:0px !important"> <span>{row.address1}  {" , "} {row.address2} </span><span><br/>    {row.address3}  {" , "}{row.provincecode}  {" "} {row.postalcode}</span></div>;                       
            },
            specialtyallowed  (h, row){ 
              switch(row.specialtyallowed.toUpperCase()){
                case 'Y':
                  return 'Yes'
                case 'N':
                  return 'No'
                default:
                  return '';
              }
            },
            
             status(h, row) {               
               if((moment(row.effectivedate,"YYYY-MM-DD").format('YYYY/MM/DD')) < moment().startOf('day').format('YYYY/MM/DD') && (moment(row.expirydate,"YYYY-MM-DD").format('YYYY/MM/DD')) > moment().startOf('day').format('YYYY/MM/DD')){
                   //return <span style="color:green" v-b-tooltip title="Active" ><i class="fas fa-check-circle"></i></span>  
                   return <span >ACTIVE</span>
                 }               
               else if((moment(row.effectivedate,"YYYY-MM-DD").format('YYYY/MM/DD')) > moment().startOf('day').format('YYYY/MM/DD')){
                   //return <span style="color:red" v-b-tooltip title="Future Dated"><i class="fa fa-arrow-circle"></i></span>  
                   return <span >FUTURE</span>
                 } 
               else 
                   //return <span style="color:red" v-b-tooltip title="Inactive"><i class="fas fa-times-circle"></i></span>                 
                   return <span>INACTIVE</span>
               }

          },
          headings: {
            info:'View',
            
            givenname: 'Given Name',
            surname: 'Surname',
            providernumber: 'Provider Number',
            //orgid: 'OrgID',
            servicetype: 'Service Type',
            servicesubtype: 'Service Sub Type',
            effectivedate: 'Effective Date',
            expirydate: 'Expiry Date',
            address: 'Address',
            // address1: 'Address',
            // address2: 'Address 2',
            // address3: 'City',
            // provincecode: 'Province',
            // postalcode: 'Postal Code',
            businessphonenumber: 'Phone',
            specialtyallowed: 'Specialty Billing',
          },
          pagination: {
            edge: true,
            nav: 'scroll',
            chunk: 5
          },
 		      sortable: ['givenname','surname','providernumber','servicetype','servicesubtype',
        'effectivedate', 'expirydate','businessphonenumber','specialtyallowed'],
          filterable: ['givenname','surname','providernumber','servicetype','servicesubtype','status',
        'effectivedate', 'expirydate','businessphonenumber','specialtyallowed'],
  
          sortIcon: {
                  base : 'fas',
                  is: 'fa-sort',
                  up: 'fa-sort-up',
                  down: 'fa-sort-down'
                  },
    }
        }
        
    },
 
        components: {

          Modal:Modal,
          Card,
          CardBody,
          TileNote,
          ProviderAddEdit,
          ProviderDetails,
          Subtitle
          
    },
  
    created: function(){
        this.showEdit = this.AllowEdit;
        this.loadTable();
    },
    mounted: function(){
         if (!this.showEdit) {
          this.columns.splice(this.columns.findIndex(column => column == 'edit'), 1);
     }},
     computed:{
          UserName(){
            return !this.$store.getters.GetCurrentUser ? false : this.$store.getters.GetCurrentUser;
        }, 
          AllAppLevel(){
            return this.$store.getters.GetAllApplevel;
          },
    },
     methods:{
        closeModal() { 
        this.showEditModal = false;
        this.loadTable();
        //this.$refs.table.refresh();
      },
        loadTable(){
        
        var vm = this;
        var url = 'SaskHealthApi/Codes/ViewProviders?_='

         var params = new URLSearchParams();
         params.append("showEdit", vm.showEdit);
         axios.get(url+Date.now(), { headers: { 'Authorization': 'Bearer ' + localStorage.access_token },params})
            .then(function (response) {
                vm.tableData=response.data;
                
                })
                .catch(function (er) {
                    //console.log(er)
                });
          },
        EditProviderPopup(Rowdata){
            this.mode='Edit';
            this.UserData = Rowdata;
            this.showEditModal=true;
        },
        AddProviderPopup(Rowdata){
            this.mode = 'Add';
             this.UserData = '';
            this.showEditModal = true;
        },
        ProviderDetailsPopup(Rowdata){
          this.showInfoModal = true;
         //this.showEdit = false;
          this.UserData = Rowdata;
        }
     }
}
</script>

<style>

</style>
